import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { EntBasicHB } from "../../../../../models/handBooks/basicHB";
import {
  useAddServiceTypeMutation,
  useDeleteServiceTypeMutation,
  useEditServiceTypeMutation
} from "../../../../../redux/api/handBooksApi/organic/serviceTypeApi";

const useServiceType = (modal: any, refresh?: () => void) => {
  const { t } = useTranslation()
  const { confirm } = modal;
  const [addServiceType] = useAddServiceTypeMutation();
  const [deleteServiceType] = useDeleteServiceTypeMutation();
  const [editServiceType] = useEditServiceTypeMutation();

  async function onAddServiceType(newServiceType: EntBasicHB): Promise<boolean> {
	try {
	  let status: boolean = false;
	  await addServiceType(newServiceType).then((response: any) => {
		if (response.error !== undefined) {

		  throw new Error(response.error.data.message);
		}
		if (response.data.success) {
		  status = true;
		  message.success(t('msg.successAdd'));
		  if (refresh) refresh();
		}
	  }).catch((error: any) => {
		modal.error({ title: t('msg.error'), content: String(error.message) });

	  });
	  return status;
	} catch (error: any) {
	  modal.error({ title: t('msg.error'), content: String(error.message) });
	  return false;
	}
  }

  async function onDeleteServiceType(serviceType: EntBasicHB) {
	try {
	  let status: boolean = false;
	  confirm({
		centered: true,
		title: t('msg.confirmDeleteText'),
		okText: t('general.yes'),
		cancelText: t('general.no'),
		onOk() {
		  deleteServiceType(serviceType.id).then((response: any) => {
			if (response.error !== undefined && response.error.status === 400) {
			  status = false;
			  throw new Error(response.error.data.message);
			}
			if (response.data.success) {
			  status = true;
			  Modal.success({ title: t('msg.successDelete') });
			  if (refresh) refresh();
			}
		  }).catch((error: any) => {
			Modal.error({ title: t('msg.error'), content: String(error.message) });

		  });
		}
	  })
	  return status
	} catch (error: any) {
	  Modal.error({ title: t("msg.error"), content: String(error.message) });
	  return false;
	}
  };

  async function onEditServiceType(editedServiceType: EntBasicHB): Promise<boolean> {
	try {
	  let status: boolean = false;
	  await editServiceType(editedServiceType).then((response: any) => {
		if (response.error !== undefined && response.error.status === 400) {
		  throw new Error(response.error.data.message);
		}
		if (response.data.success) {
		  status = true;
		  Modal.success({ title: t('msg.successEdited') });
		  if (refresh) refresh();
		}
	  }).catch((error: any) => {
		Modal.error({ title: t('msg.error'), content: String(error.message) });
	  });
	  return status;
	} catch (error: any) {
	  Modal.error({ title: t("msg.error"), content: String(error.message) });
	  return false;
	}
  };
  return { onAddServiceType, onDeleteServiceType, onEditServiceType }

}
export { useServiceType };

